import React from 'react';
import { renderToString } from 'react-dom/server';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import EmailBody from '../SendModal/EmailBody/EmailBody';
import { required, faxNumber, maxLength } from '@src/validation';
import { Editor } from '@tinymce/tinymce-react';
import axiosInstance from '@src/axios-instance';
import CSS from '@components/EvidenceOfInsurance/EvidenceOfInsuranceEdit/SendModal/SendModal.module.scss';

const fieldValidator = {
  body: [],
  fax_number: [required, faxNumber, value => maxLength(value, 255)]
};

class FaxModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};

    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value:
          props.entity[key] !== undefined && props.entity[key] !== null
            ? props.entity[key]
            : '',
        visited: false,
        error: false
      };
    });

    fields.body.value = renderToString(<EmailBody entity={props.entity} />);
    this.state = { ...fields };
  }

  setSubmitType = name => {
    this.setState({
      submitType: name
    });
  };

  updateForm = (event, name) => {
    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event,
      visited: true,
      error: false
    };

    const validator = fieldValidator;
    for (let i = 0; i < validator[name].length; i++) {
      const validationMsg = validator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    const validator = fieldValidator;

    Object.keys(validator).forEach(key => {
      postData[key] =
        formData[key].value.value !== undefined
          ? formData[key].value.value
          : formData[key].value;
      for (let i = 0; i < validator[key].length; i++) {
        const validationMsg = validator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });
    this.setState({ ...formData });

    if (isValid) {
      this.props.onSubmit(postData);
    }

    return false;
  };

  downloadPDF = (response, name) => {
    const byteCharacters = window.atob(response);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  downloadEmailAttachment = type => {
    this.props.loading(true);
    axiosInstance()
      .get(
        `/evidence-of-insurances/download-email-attachment/${this.props.entity.id}/${type}.json`
      )
      .then(response => {
        this.props.loading(false);
        this.downloadPDF(response.data.response, response.data.name);
      })
      .catch(err => {
        this.props.loading(false);
      });
  };

  render = () => {
    const attachments = [];
    const { entity } = this.props;
    let pdfName = `${entity.unit.address_no}_${entity.unit.street}_${entity.unit.unit_no}.pdf`.replace(
      ' ',
      '_'
    );
    attachments.push(
      <span
        key={'eoi-pdf-attachment'}
        className={'pointer'}
        onClick={() => this.downloadEmailAttachment('eoi')}
      >
        {pdfName}
      </span>
    );
    if (
      entity.include_sample_quote === 1 &&
      entity.unit.association.sample_quote !== null
    ) {
      pdfName = entity.unit.association.sample_quote
        .replace(/^.*[/]/, '')
        .replace(' ', '_');
      attachments.push(', ');
      attachments.push(
        <span
          key={'sample-quote-attachment'}
          className={'pointer'}
          onClick={() => this.downloadEmailAttachment('sample-quote')}
        >
          {pdfName}
        </span>
      );
    }

    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>{'Fax'}</ModalHeader>
          <div className={'position-relative'}>
            <ModalBody className={'p-4'}>
              <Row>
                <Col xs={12}>
                  <LabelInput
                    name={'Fax (Separate fax numbers with a comma)'}
                    type={'text'}
                    required={true}
                    {...this.state.fax_number}
                    onChange={event => this.updateForm(event, 'fax_number')}
                  />
                </Col>
                <Col xs={12} className={'pt-1'}>
                  <Editor
                    apiKey="4mz6kr57dqdqs584hnltw8r5555fnbt0m3p6ss5c9m7zubk1"
                    cloudChannel="dev"
                    initialValue={this.state.body.value}
                    init={{
                      height: 500
                    }}
                    onChange={event =>
                      this.updateForm(event.target.getContent(), 'body')
                    }
                  />
                </Col>
                <Col xs={12} className={'pt-2'}>
                  <span>
                    <strong>Attachment: </strong>
                    <span className={CSS.attachments}>{attachments}</span>
                  </span>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4 justify-content-end'}>
              <Button
                color="primary"
                className={'btn px-3'}
                type={'submit'}
                onClick={this.props.toggle}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                className={'btn px-3'}
                type={'submit'}
                onClick={() => this.setSubmitType('email')}
              >
                Fax
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default FaxModal;
